import React from 'react';
import { ShieldCheck } from 'lucide-react';
export const Guarantee = () => {
  return <section className="py-16 bg-white" data-id="element-61">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-62">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-barre-blush rounded-full mb-6" data-id="element-63">
          <ShieldCheck className="w-10 h-10 text-barre-pink" data-id="element-64" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-65">
          Garantía de Satisfacción de 7 Días
        </h2>
        <p className="text-lg text-gray-600" data-id="element-66">
          Estamos tan seguras de la calidad de este material que te ofrecemos
          una garantía incondicional. Si comprás el pack, lo revisás y sentís
          que no te aporta valor para tu estudio, nos mandás un email dentro de
          los primeros 7 días y te devolvemos el 100% de tu dinero. Sin
          preguntas.
        </p>
      </div>
    </section>;
};